<script setup>
import { get_option } from '@/services/packages';
import { swalError } from '@/helper';
import { onMounted, ref } from 'vue';

const isLoading = ref(true)
onMounted(async()=>{
  await get_latest_info()
  isLoading.value = false
})

const info = ref('')
async function get_latest_info(){
  let response = await get_option('latest_information')
  if (response.error){
    swalError(response.result, true)
    return
  }
  info.value = parseInfo(response.result.data.attributes.name)
}

function parseInfo(result){
  if (result == ''){
    return { title: '', description: ''}
  }
  let data = JSON.parse(result)
  
  // Convert http/https URLs to clickable links and avoid matching trailing punctuation
  const urlRegex = /(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/g;
  let linkedDescription = data.description.replace(urlRegex, '<a href="$1" target="_blank" class="text-primary text-decoration-underline" rel="noopener noreferrer">$1</a>')
  
  // Replace newlines with <br /> for HTML rendering
  let filteredDescription = linkedDescription.replace(/\r?\n/g, '<br />')
  
  return { title: data.title, description: filteredDescription}
}
</script>

<template>
  <loadingCard v-if="isLoading"/>
  <div v-else class="card">
    <div class="card-header">
      <h5>Latest Information</h5>
    </div>
    <div class="card-body">
      <div class="info-content-scroll">
        <h4>{{ info.title }}</h4>
        <p v-html="info.description" />
      </div>
    </div>
    <ul class="square-group">
      <li class="square-1 warning"></li>
      <li class="square-1 primary"></li>
      <li class="square-2 warning1"></li>
      <li class="square-3 danger"></li>
      <li class="square-4 light"></li>
      <li class="square-5 warning"></li>
      <li class="square-6 success"></li>
      <li class="square-7 success"></li>
    </ul>
  </div>
</template>

<style scoped>
.info-content-scroll {
  height: 400px;
  overflow-y: auto;
  padding-right: 10px;
}

.info-content-scroll::-webkit-scrollbar {
  width: 6px;
}
.info-content-scroll::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
.info-content-scroll::-webkit-scrollbar-thumb {
  background: #c1c1c1; 
  border-radius: 3px;
}
.info-content-scroll::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8; 
}
</style>